import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { Grid, InputAdornment, Tooltip } from '@mui/material';

import { modelPath } from '@libs/helpers/form';
import { ConnectedTextField } from '@libs/ui/components/form/text-field';

import { ApplicationFormState } from '../../types';

interface BirthDateFieldsProps {
  showOnlyRequired?: boolean;
}

/**
 * Reusable component for month and day of birth fields
 * Used in both Default and Bayer Social Security ID components
 */
export const BirthDateFields: React.FC<BirthDateFieldsProps> = ({
  showOnlyRequired = false,
}) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6}>
        <ConnectedTextField
          name={modelPath<ApplicationFormState>((i) => i.details.monthOfBirth)}
          fullWidth
          variant="filled"
          label="Month of birth"
          placeholder="2"
          type="number"
          inputProps={{ min: 1, max: 12 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Month of birth (1-12)">
                  <InfoIcon fontSize="small" />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ConnectedTextField
          name={modelPath<ApplicationFormState>((i) => i.details.dayOfBirth)}
          fullWidth
          variant="filled"
          label="Day of birth"
          placeholder="5"
          type="number"
          inputProps={{ min: 1, max: 31 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Day of birth (1-31)">
                  <InfoIcon fontSize="small" />
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </Grid>
  );
};
